import { CustomerBookingType } from '../../Models/DTO/Customer.model';
import { NeoState } from '../Reducers.interface';

export const selectCustomerProfile = (state: NeoState) =>
  state.customers.customerProfile.profile || null;

export const selectCustomerInvited = (state: NeoState) =>
  state.customers.customerProfile.invitationSent;

export const selectCustomerDisconnected = (state: NeoState) =>
  state.customers.customerProfile.customerDisconnected;

export const selectActiveBookings = (maxResults: number) => (state: NeoState) =>
  state.customers.customerBookings.active?.slice(0, maxResults) ?? null;
export const selectCancelledBookings = (maxResults: number) => (state: NeoState) =>
  state.customers.customerBookings.cancelled?.slice(0, maxResults) ?? null;
export const selectPastBookings = (maxResults: number) => (state: NeoState) =>
  state.customers.customerBookings.past?.slice(0, maxResults) ?? null;

const bookingSelectors = {
  [CustomerBookingType.ACTIVE]: selectActiveBookings,
  [CustomerBookingType.CANCELLED]: selectCancelledBookings,
  [CustomerBookingType.PAST]: selectPastBookings,
};

export const selectBookingsByType = (type: CustomerBookingType, maxResults: number = 3) =>
  bookingSelectors[type](maxResults);
